import { Timeline } from "primereact/timeline";
import { registerSectionType } from "../../utils/sectionRegistry";
import { Section } from "../sectionHelpers";

registerSectionType({
  type: "lineaTiempo",
  label: "Linea de tiempo",
  layout: "accordion",
  previewBlocks: ["Hito", "Hito", "Hito"],
  getDefaults: () => ({ type: "lineaTiempo", title: "", description: "", itemsText: "", draft_title: "", draft_subtitle: "", draft_description: "" }),
  editorFields: [
    { key: "title", label: "Titulo del hito" },
    { key: "subtitle", label: "Ano o subtitulo del hito" },
    { key: "description", label: "Descripcion del hito", input: "textarea" },
  ],
  itemLabel: "hito",
  render: (section, index) => {
    const items = Array.isArray(section?.items) ? section.items : [];
    const contentTemplate = (item) => (
      <div className="dynamic-timeline-content">
        {item?.title ? <h3>{item.title}</h3> : null}
        {item?.subtitle ? <span className="dynamic-timeline-subtitle">{item.subtitle}</span> : null}
        {item?.description ? <p>{item.description}</p> : null}
      </div>
    );
    const marker = () => <i className="pi pi-circle-fill dynamic-timeline-marker" />;
    return (
      <Section section={section} className="dynamic-section-timeline" keyName={`timeline-${index}`}>
        <Timeline value={items} align="alternate" className="customized-timeline" marker={marker} content={contentTemplate} />
      </Section>
    );
  },
});
